"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
var ThemeProvider_1 = require("../ThemeProvider");
exports.cardTheme = function (theme) {
    var componentTheme = {
        headerFont: ThemeProvider_1.renderFont('base', 'normal', theme),
        headlineSize: '1rem',
        headlineLineHeight: '1.313rem',
        headlineFontWeight: '500',
        headlineColor: theme.base.color.text,
        headlineLetterSpacing: 'normal',
        subheadlineSize: '0.813rem',
        subheadlineLineHeight: '1.125rem',
        subheadlineCondensedSize: '0.6rem',
        subheadlineCondensedLineHeight: '0.85rem',
        subheadlineFontWeight: 'normal',
        subheadlineColor: theme.base.color.textTransparent,
        subheadlineLetterSpacing: '0.2px',
        bgColor: theme.base.color.normal,
        seperatorColor: theme.greyNormal.color.normal,
        seperatorSize: '4px',
        activeColor: theme.primary.color.normal,
    };
    if (theme.component.cardwrapper) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.cardwrapper);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { cardwrapper: componentTheme }) });
};
exports.default = exports.cardTheme;
//# sourceMappingURL=theme.js.map